import PropTypes from 'prop-types'
import React from 'react'
import { ThemeContext } from 'styled-components'

import HowToBlock from 'components/_special/HowToBlock'
import SectionWrapper from 'components/SectionWrapper'
import { LocalizationContext } from 'contexts/Localization'
import { Text } from 'styles/components/typography'

import { ChipWrapper, ChipImg } from './styles'

/**
 * DHowAnalyse
 *
 * @param {object} props - properties of component
 * @returns {node} DHowAnalyse
 */
const DHowAnalyse = ({ data, index, isSquareHidden }) => {
  const { colors } = React.useContext(ThemeContext)
  const {
    paths: { shared },
  } = React.useContext(LocalizationContext)
  const imagesPath = `${shared}/dna_how`

  return (
    <SectionWrapper isOverflowHidden={true} classNameWrapper="bg--green">
      <HowToBlock
        isSquareHidden={isSquareHidden}
        title={data.title}
        index={index}
        squareColor={colors.white}
        lineColor="light"
      >
        <div className="row">
          <div className="col-12 col-md-5 col-lg-5 offset-md-1 pb-2 pb-md-4 pb-lg-0">
            <Text
              className="text--white with-inverted-links"
              dangerouslySetInnerHTML={{ __html: data.content }}
            />
          </div>
          <div className="col-12 col-md-6">
            <ChipWrapper>
              <ChipImg
                image={`${imagesPath}/illumina_chip`}
                imageSizes={{
                  xs: 250,
                  md: 320,
                }}
                alt="illumina"
                imageType="png"
              />
            </ChipWrapper>
          </div>
        </div>
      </HowToBlock>
    </SectionWrapper>
  )
}

DHowAnalyse.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  isSquareHidden: PropTypes.bool,
}

DHowAnalyse.defaultProps = {
  isSquareHidden: false,
}

export default DHowAnalyse
